import { LanguagesCodes } from 'utils/enums/language';
import { ThemeMode } from 'utils/enums/theme';
import { ToastType } from 'utils/enums/toast-types';
import { MConfirmModalProps } from 'views/MConfirmModal/MConfirmModal.model';
import { MToastProps } from 'views/MToast/MToast.model';

export enum UIActions {
  SetTheme = '[UI] Set Change Theme',
  SetThemes = '[UI] Set Themes styles',
  SetLanguage = '[UI] Set Language',
  ShowSpinner = '[UI] Show Spinner',
  ShowConfirmModal = '[UI] Show Confirm Modal',
  HideConfirmModal = '[UI] Hide Confirm Modal',
  SetAside = '[UI] Set Aside',
  SetPageName = '[UI] Set Page Name',
  showErrorToast = '[UI] Show Error Toast',
  showSuccessToast = '[UI] Show Success Toast',
  hideToast = '[UI] Hide Toast',
  SetHideRoiSimulation = '[UI] Set Hide ROI Simulation',
}

export type ShowConfirmModal = {
  type: UIActions.ShowConfirmModal;
  payload: MConfirmModalProps;
};

export type HideConfirmModal = {
  type: UIActions.HideConfirmModal;
};

export type SetThemes = {
  type: UIActions.SetThemes;
  payload: {
    type: {
      fontFamily?: string | null;
      dark: { [key: string]: string } | null;
      light: { [key: string]: string } | null;
    };
  };
};

export type SetTheme = {
  type: UIActions.SetTheme;
  payload: { type: ThemeMode };
};

export type SetLanguage = {
  type: UIActions.SetLanguage;
  payload: { type: LanguagesCodes };
};

export type SetAside = {
  type: UIActions.SetAside;
  payload: { show: boolean };
};

export type SetPageName = {
  type: UIActions.SetPageName;
  payload: { text: string };
};

export type ShowSpinner = {
  type: UIActions.ShowSpinner;
  payload: { state: number | boolean };
};

export type ShowErrorToast = {
  type: UIActions.showErrorToast;
  payload: MToastProps;
};

export type ShowSuccessToast = {
  type: UIActions.showSuccessToast;
  payload: MToastProps;
};

export type HideToast = {
  type: UIActions.hideToast;
};

export type SetHideRoiSimulation = {
  type: UIActions.SetHideRoiSimulation;
  payload: { hide: boolean };
};

// Action creators
export const showConfirmModal = (modal: MConfirmModalProps): ShowConfirmModal => {
  return {
    type: UIActions.ShowConfirmModal,
    payload: { ...modal, isOpen: true },
  };
};

export const hideConfirmModal = (): HideConfirmModal => {
  return {
    type: UIActions.HideConfirmModal,
  };
};

export const setTheme = (type: ThemeMode): SetTheme => {
  return {
    type: UIActions.SetTheme,
    payload: { type },
  };
};

export const setLanguage = (language: LanguagesCodes): SetLanguage => {
  return {
    type: UIActions.SetLanguage,
    payload: { type: language },
  };
};

export const setThemes = (
  themes: { dark: { [key: string]: string } | null; light: { [key: string]: string } | null },
  fontFamily?: string | null,
): SetThemes => {
  return {
    type: UIActions.SetThemes,
    payload: { type: { dark: themes.dark, light: themes.light, fontFamily } },
  };
};

export const setAside = (state: boolean): SetAside => {
  return {
    type: UIActions.SetAside,
    payload: { show: state },
  };
};

export const SetPageName = (text: string): SetPageName => {
  return {
    type: UIActions.SetPageName,
    payload: { text },
  };
};

export const showSpinner = (state: boolean | number): ShowSpinner => {
  return {
    type: UIActions.ShowSpinner,
    payload: { state },
  };
};

export const showErrorToast = (toast: MToastProps = {}): ShowErrorToast => {
  return {
    type: UIActions.showErrorToast,
    payload: { ...toast, type: ToastType.Error },
  };
};

export const showSuccessToast = (toast: MToastProps): ShowSuccessToast => {
  return {
    type: UIActions.showSuccessToast,
    payload: { ...toast, type: ToastType.Success },
  };
};

export const hideToast = (): HideToast => {
  return {
    type: UIActions.hideToast,
  };
};

export const setHideRoiSimulation = (hide: boolean): SetHideRoiSimulation => {
  return {
    type: UIActions.SetHideRoiSimulation,
    payload: { hide },
  };
};

// Types

export type UITypes =
  | SetTheme
  | SetThemes
  | SetAside
  | SetPageName
  | ShowSpinner
  | ShowErrorToast
  | ShowSuccessToast
  | HideToast
  | ShowConfirmModal
  | HideConfirmModal
  | SetLanguage
  | SetHideRoiSimulation;
